import translate from "@insite/client-framework/Translate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface Props {
    paymentTermsDescription: string;
    isFreightWidget?: boolean;
}

export interface PaymentTermsStyles {
    paymentTerms?: InjectableCss;
    paymentTermsGridItem?: GridItemProps;
    headingText?: TypographyProps;
}

export const paymentTermsStyles: PaymentTermsStyles = {
    paymentTerms: {
        css: css`
            font-style: normal;
            color: ${getColor("text.main")};
            font-family: Lato;
            font-size: 18px;
            letter-spacing: 0;
            line-height: 32px;
        `,
    },
    paymentTermsGridItem: {
        width: 10,
        css: css`
            align-items: baseline;
            padding: 0;
            margin: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 16px;
                            line-height: 24px;
                        `,
                        null,
                        null,
                        css`
                            font-size: 18px;
                            line-height: 32px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    headingText: {
        variant: "h5",
    },
};

const titleStyle1 = () => `
    font-size: 14px;
    line-height: 30px;
`;

const titleStyle2 = () => `
    font-family: "IndustryInc", "Lato", "Open Sans", "Roboto", sans-serif;  
    font-size: 16px;
    color: #696f72;
`;

const descriptionStyle1 = () => `
    font-size: 14px;
    line-height: 30px;
`;

const descriptionStyle2 = () => `
    font-size: 18px;
`;

const styles = paymentTermsStyles;

const PaymentTerms: React.FunctionComponent<Props> = ({ paymentTermsDescription, isFreightWidget }: Props) => {
    const titleStyles = {
        css: css`
            ${isFreightWidget ? titleStyle1() : titleStyle2()}
        `,
    };

    const descriptionStyles = {
        css: css`
            ${isFreightWidget ? descriptionStyle1() : descriptionStyle2()}
        `,
    };

    if (!paymentTermsDescription) {
        return null;
    }

    return (
        <GridItem {...styles.paymentTermsGridItem}>
            <Typography {...titleStyles}>{translate("Payment Terms")}: </Typography>
            <Typography {...descriptionStyles}>{paymentTermsDescription}</Typography>
        </GridItem>
    );
};

export default PaymentTerms;
